import { render, staticRenderFns } from "./PlayPastPuzzles.vue?vue&type=template&id=9a74e290&"
import script from "./PlayPastPuzzles.vue?vue&type=script&lang=js&"
export * from "./PlayPastPuzzles.vue?vue&type=script&lang=js&"
import style0 from "./PlayPastPuzzles.vue?vue&type=style&index=0&id=9a74e290&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports